// extracted by mini-css-extract-plugin
module.exports = {"attribute":"_448fc52","icon":"_42bd791","text":"_fd14012","running":"_ad3512d","lateReg":"_43cba8b","announced":"_8e81a00","cancelled":"_bb5fe3b","completed":"_4c424c7"};